export default __webpack_public_path__ + "static/media/Monger-HUD-Radar.46d489e1.jpg";